import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  ListGroupItem,
  ListGroupItemHeading,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import Avatar from "../common/Avatar";
import FontAwesomeIcon from "../../helpers/fontawesome/fontAwesome";
import { useSelector } from "react-redux";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { findAllProperties } from "../../helpers/api/condominium";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { Or } from "../UI/preloading/PreloadState";
import { Link, useHistory } from "react-router-dom";
import { Toast } from "../UI/toast/Toast";
import { getConfigAsRoot } from "../../helpers/api/root";
import NumberFormat from "react-number-format";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";

const ListItem = ({
  id,
  mutate,
  avatar,
  title,
  alternativeName,
  onDeleteAction,
  onSeeAction,
  onSeeProperties,
  onSeeAlicuota,
  onSeeFinances,
  onEditAction,
  onChangeMoney,
  condominiumId,
  options,
  createdAt,
  onClick,
  status,
  solved,
  propertiesCount,
  pricesConfig,
  ...rest
}) => {
  moment.locale("es");
  const { acronym } = rest;
  const history = useHistory();
  const [properties, setProperties] = useState(null);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { baseCurrency } = useContext(CurrencyContext);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [nameValidation, setNameValidation] = useState(null);
  const [prices, setPrices] = useState(null);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(null);


  useEffect(() => {
    if (propertiesCount !== undefined) {
      setProperties(propertiesCount);
    }
  }, [propertiesCount]);

  useEffect(() => {
    if (pricesConfig) {
      setPrices(pricesConfig);
    }
  }, [pricesConfig]);

  const handleDropdownAction = (action) => {
    if (action === "edit") {
      onEditAction(rest);
      return;
    }
    if (action === "delete") {
      return collapseOneOpen(true);
    }
    throw new Error("invalid action");
  };

  useEffect(() => {
    if (prices && properties) {
      setPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prices, properties]);

  const handleDelete = () => {
    collapseOneOpen(false);
    onDeleteAction();
  };

  const setPrice = () => {
    if (properties) {
      const array = prices?.filter(
        (val) => properties >= val.min && properties <= val.max
      );
      const arrayPrice = array?.find(
        (val) => properties >= val.min && properties <= val.max
      );
      setTotal(arrayPrice?.price ? arrayPrice.price : "Out of range");
      setLoading(false);
    }
  };

  const validateCondominiumNameOnDelete = () => {
    return nameValidation === title;
  };

  const jsUcfirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleActionButton = async (e, action) => {
    e.preventDefault();
    e.stopPropagation();
    await onClick();

    if (solved) {
      Toast.fire(
        "No puedes realizar esta acción porqué tu condominio está desactivado.",
        `Razón: ${solved?.reason}`,
        "error"
      );
      return;
    }

    let path = "";

    switch (action) {
      case "properties":
        path = `/dashboard/properties`;
        break;

      case "banks":

        path = `/dashboard/banks`;
        break;

      case "alicuota":
        // Corresponde a la ruta de 'Alícuotas': /dashboard/finance/COND_ID/aliquots
        path = `/dashboard/finance/${condominiumId}/aliquots`;
        break;

      default:
        return;
    }

    if (path) {
      setTimeout(() => {
        history.push(path);
      }, 500);
    }
  };

  const handleModal = () => {
    return (
      <Modal isOpen={collapseOne} data-testid="modal">
        <ModalHeader>Eliminar {title}</ModalHeader>
        <ModalBody>
          <p className="mb-0 font-weight-bold fs--1">
            Para continuar ingresa el nombre del {alternativeName} {title}
          </p>
          <FormGroup className="mt-1">
            <Input
              data-testid="validation-input"
              type="text"
              name="condominiumname"
              placeholder="Nombre"
              onChange={(e) => setNameValidation(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => collapseOneOpen(!collapseOne)}>Cancelar</Button>
          <Button
            data-testid="delete-button"
            disabled={!validateCondominiumNameOnDelete()}
            color="danger"
            onClick={handleDelete}
          >
            Eliminar
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  return (
    <ListGroupItem
      className="shadow-none border-top"
      data-testid="CondominiumItem"
      style={{
        margin: "0px 15px",
        cursor: "pointer",
        borderLeft: `3px solid ${selectedCondominium === condominiumId ? "#8725a8" : "#cccccc"
          }`,
      }}
    >
      <ListGroupItemHeading>
        <Row>
          <Col
            onClick={() => {
              if (!solved) {
                onClick();
              } else {
                Toast.fire(
                  "No puedes realizar esta acción porqué tu condominio está desactivado.",
                  `Razón: ${solved?.reason}`,
                  "error"
                );
              }
            }}
          >
            <Row className="p-2">
              {avatar && (
                <Col xs="auto" className="d-flex align-items-center">
                  <Avatar src={avatar} rounded="soft" className="" size="4xl" />
                </Col>
              )}
              <Col className="d-flex justify-content-center flex-column">
                <Row className="justify-content-start align-items-center p-1">
                  <h5
                    id="bReason"
                    className={`${selectedCondominium === condominiumId ? "text-info" : ""
                      } m-0 mr-2`}
                  >
                    {acronym?.toUpperCase()} - {title}
                  </h5 >
                  <Or cond={!solved}>
                    <Badge
                      value={true}
                      color={"success"}
                      className="badge-pill d-none d-md-inline-block"
                      style={{ fontSize: "12px", fontWeight: "initial" }}
                    >
                      Servicio activo
                    </Badge>
                    <Badge
                      value={false}
                      className="badge-pill d-none d-md-inline-block"
                      style={{ fontSize: "12px", fontWeight: "initial" }}
                      color={"danger"}
                    >
                      Desactivado
                    </Badge>
                    <UncontrolledTooltip
                      value={false}
                      placement="top"
                      target="bReason"
                    >
                      Razón: <b>{solved?.reason}</b>
                    </UncontrolledTooltip>
                  </Or>
                </Row >
                {properties !== null && (
                  <Row className="justify-content-start align-items-center p-1">
                    <small className="d-block">
                      {`Propiedad${properties !== 1 && "es"} en total: ${String(
                        properties
                      )}`}
                    </small>
                  </Row>
                )}
                {
                  properties !== null && (
                    <Row className="justify-content-start align-items-center p-1">
                      <small className="d-block pr-2">
                        {"Pago aproximado: "}
                        <NumberFormat
                          prefix={`${baseCurrency.symbol} `}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale
                          value={properties * 1}
                        />
                      </small>
                      {status?.charge?.paid === 1 && solved ? (
                        <Badge
                          className="badge-pill d-none d-md-inline-block"
                          color={"success"}
                          style={{ fontSize: "12px", fontWeight: "initial" }}
                        >
                          Solvente
                        </Badge>
                      ) : status?.charge?.paid === 0 ? (
                        <Badge
                          value={false}
                          className="badge-pill d-none d-md-inline-block"
                          color={"danger"}
                          style={{ fontSize: "12px", fontWeight: "initial" }}
                        >
                          Insolvente
                        </Badge>
                      ) : (
                        <Badge
                          className="badge-pill d-none d-md-inline-block"
                          color={"success"}
                          style={{ fontSize: "12px", fontWeight: "initial" }}
                        >
                          Solvente Solvente
                        </Badge>
                      )}
                    </Row>
                  )
                }
                <Row className="justify-content-start align-items-center p-1 mt-1">
                  <Button
                    color="primary"
                    size="sm"
                    className="me-2 custom-btn mr-2"
                    style={{
                      borderRadius: "4px",
                      fontWeight: "500",
                      fontSize: "12px",
                      padding: "4px 10px",
                      lineHeight: "1.2",
                      minHeight: "28px",
                    }}
                    onClick={(e) => handleActionButton(e, "properties")}
                  >
                    <i className="fas fa-home fa-xs me-1"></i>
                    Propiedades
                  </Button>
                  <Button
                    color="success"
                    size="sm"
                    className="me-2 custom-btn mr-2"
                    style={{
                      borderRadius: "4px",
                      fontWeight: "500",
                      fontSize: "12px",
                      padding: "4px 10px",
                      lineHeight: "1.2",
                      minHeight: "28px",
                    }}
                    onClick={(e) => handleActionButton(e, "banks")}
                  >
                    <i className="fas fa-university fa-xs me-1"></i>
                    Bancos
                  </Button>
                  <Button
                    color="info"
                    size="sm"
                    className="custom-btn"
                    style={{
                      borderRadius: "4px",
                      fontWeight: "500",
                      fontSize: "12px",
                      padding: "4px 10px",
                      lineHeight: "1.2",
                      minHeight: "28px",
                    }}
                    onClick={(e) => handleActionButton(e, "alicuota")}
                  >
                    <i className="fas fa-calculator fa-xs me-1"></i>
                    Alicuota
                  </Button>
                </Row>
              </Col >
            </Row >
          </Col >
          {options && (
            <Col xs="auto" className="d-sm-flex align-items-center">
              <UncontrolledDropdown
                direction="left"
                className="d-inline-block ml-2"
              >
                <DropdownToggle color="falcon-default">
                  <FontAwesomeIcon icon="ellipsis-h" />
                </DropdownToggle>
                <DropdownMenu>
                  <Or cond={!solved}>
                    {/* <DropdownItem
                      tag={Link}
                      to={`/dashboard/finance/${condominiumId}/my/service`}
                      className="py-2"
                      value={true}
                    >
                      Estado del servicio
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      className="py-2"
                      value={false}
                      to={`/dashboard/finance/${condominiumId}/my/service`}
                    >
                      Estado del servicio
                    </DropdownItem>
                    <DropdownItem divider value={true} /> */}
                    <DropdownItem
                      className="py-2"
                      value={false}
                      to={`/dashboard/finance/${condominiumId}/my/service/${condominiumId}`}
                      tag={Link}
                    >
                      Pagos realizados
                    </DropdownItem>
                    <DropdownItem
                      className="py-2"
                      value={true}
                      onClick={onEditAction}
                    >
                      Editar
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to={`/dashboard/properties`}
                      className="py-2"
                      value={true}
                    >
                      Propietarios
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      to={`/dashboard/finance/${condominiumId}/aliquots`}
                      className="py-2"
                      value={true}
                    >
                      Alícuotas
                    </DropdownItem>

                    <DropdownItem
                      className="py-2"
                      value={true}
                      to={`/dashboard/banks`}
                      onClick={onSeeAction}
                    >
                      Ver bancos
                    </DropdownItem>
                    <DropdownItem
                      className="py-2"
                      value={true}
                      onClick={onChangeMoney}
                    >
                      Cambiar de moneda
                    </DropdownItem>
                    <DropdownItem className="py-2" value={true} divider />
                    <DropdownItem
                      className="py-2 text-danger"
                      value={true}
                      onClick={() => handleDropdownAction("delete")}
                    >
                      Eliminar {alternativeName}
                    </DropdownItem>
                  </Or>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Col>
          )}
        </Row >
      </ListGroupItemHeading >
      {handleModal()}
    </ListGroupItem >
  );
};

export default ListItem;
